module.exports = __webpack_public_path__ + "img/ring_y_o_null_1@2x.1e5cecc5.png";